<template>
  <div class="filtro-autos">
    <v-form name="myform">
      <v-card class="mb-10">
        <v-card-title class="subtitle-1">Filtros</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="2" sm="12">
              <v-text-field hide-details dense label="Filtrar por Agentes" v-model="filtro.agente" outlined></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="12">
              <v-btn
                text
                color="primary"
                @click="toggleMaisFiltros = !toggleMaisFiltros"
              >{{toggleMaisFiltros ? 'Menos' : 'Mais'}} filtros</v-btn>
            </v-col>
          </v-row>
          <template v-if="toggleMaisFiltros">
            <v-row>
              <v-col cols="12" md="2" sm="12">
                <v-select hide-details dense outlined  label="Status" :items="items" v-model="filtro.status"></v-select>
              </v-col>
                <v-col cols="12" md="2" sm="12">
                  <v-text-field
                    dense
                    type="date"
                    label="Data Infração (Início)"
                    v-model="filtro.data_inicio"
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" sm="12">
                  <v-text-field
                    dense
                    type="date"
                    label="Data Infração (Fim)"
                    v-model="filtro.data_fim"
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" type="submit" @click.prevent="input(filtro)">Pesquisar</v-btn>
          <v-btn color="primary" outlined class="ml-5" @click.prevent="resetFiltro">Limpar</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>
<script>

export default {
  name: "FiltroRelatorioLotesInfracao",
  data() {
    return {
      enquadramentos: [],
      toggleMaisFiltros: false,
      filtro: {},
      items: ['valida','invalida']
    };
  },
  methods: {
    input(filtro) {
      this.$emit("input", filtro);
    },
    resetFiltro() {
      this.filtro = {};
    },
  },
};
</script>
